import { FunctionComponent, useState } from "react";
import { ConsentTexts, CookieDetail } from "./texts";

type CookieDetailsProps = {
  t: ConsentTexts;
  cookies: CookieDetail[];
  id: string;
};

// Expandable table: name, provider, purpose and storage period per cookie.
export const CookieDetails: FunctionComponent<CookieDetailsProps> = ({
  t,
  cookies,
  id,
}) => {
  const [open, setOpen] = useState(false);
  const tableId = `swt-consent-details-${id}`;

  return (
    <div className="swt-consent__details">
      <button
        type="button"
        className="swt-consent__details-toggle"
        aria-expanded={open}
        aria-controls={tableId}
        onClick={() => setOpen(!open)}
      >
        {open ? t.hideDetails : t.showDetails}
      </button>
      {open && (
        <table id={tableId} className="swt-consent__table">
          <thead>
            <tr>
              <th>{t.colName}</th>
              <th>{t.colProvider}</th>
              <th>{t.colPurpose}</th>
              <th>{t.colDuration}</th>
            </tr>
          </thead>
          <tbody>
            {cookies.map((cookie) => (
              <tr key={cookie.name}>
                <td>{cookie.name}</td>
                <td>{cookie.provider}</td>
                <td>{cookie.purpose}</td>
                <td>{cookie.duration}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
